// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"0b3f06de","898":"1a549f8a"}[chunkId] + ".chunk.js";
};